import { produce } from "immer";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";

import { ChartData, StemLineChart } from "@examspark/types";

import QuestionContext from "../../QuestionContext";
import LineChart from "../common/graph/line-chart/LineChart";
import OutcomeMark from "../OutcomeMark";
import Prompt from "../shared/Prompt";

const Wrapper = styled.div`
  max-width: 55rem;
`;

export interface QuestionLineChartProps {
  data: StemLineChart;
}

const LineChartQuestion: React.FC<
  React.PropsWithChildren<QuestionLineChartProps>
> = (props) => {
  const [player, dispatchPlayer] = useContext(QuestionContext);
  const [data, setData] = useState<ChartData>(props.data.content.data);

  // Reveal Key
  useEffect(() => {
    if (player.revealKey) {
      dispatchPlayer({
        type: "RESPONSE",
        data: {
          score: true,
          id: props.data.id,
          response: {
            chart: props.data.scoring.data.map((v) => ({
              value: v.value,
            })),
          },
        },
      });
    }
  }, [player.revealKey]);

  let mark: "correct" | "incorrect" | undefined = undefined;
  if (player.scoreResponses) {
    mark = "correct";

    if (!player.response?.[props.data.id]) {
      mark = "incorrect";
    } else {
      for (const key in props.data.scoring.data) {
        if (
          Object.prototype.hasOwnProperty.call(props.data.scoring.data, key)
        ) {
          const element = props.data.scoring.data[key];
          if (
            Number(element.value) !==
            Number(player.response[props.data.id]?.chart[key].value)
          ) {
            mark = "incorrect";
          }
        }
      }
    }
  }

  return (
    <>
      <Prompt data={props.data.content.prompt} />
      <Wrapper>
        <OutcomeMark mark={mark}>
          <LineChart
            graph={produce(props.data.config.graph, (draft) => {
              draft.x.max = data.length - 1;
            })}
            data={produce(data, (draft) => {
              if (player.response?.[props.data.id]?.chart?.length) {
                for (const key in player.response[props.data.id].chart) {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      player.response[props.data.id].chart,
                      key,
                    )
                  ) {
                    const element = player.response[props.data.id].chart[key];
                    draft[Number(key)].value = element.value;
                  }
                }
              }
            })}
            onChange={(data) => {
              dispatchPlayer({
                type: "RESPONSE",
                data: {
                  id: props.data.id,
                  response: {
                    chart: data,
                  },
                },
              });
            }}
          />
        </OutcomeMark>
      </Wrapper>
    </>
  );
};

export default LineChartQuestion;
